export default __webpack_public_path__ + "static/media/pomodoro2.92bbd5bb.png";